export const getById = (list, id) => {
  return list.find((x) => x.id === id);
};
